import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Autocomplete,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { ProvinciaContext } from '../ProvinciaContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const ProvinciaSchema = Yup.object().shape({
    descrizione: Yup.string().required("Il nome è un campo obbligatorio"),
});

export const ProvinciaDetailsForm = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,

        isLoadingRegioni,
        getRegioniAsync,
    } = useContext(ProvinciaContext);

    const {
        provincia,
        regioni,
        regioniOptions,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        regioneId: provincia?.regioneId ?? null,
                        descrizione: provincia?.descrizione ?? "",
                        sigla: provincia?.sigla ?? "",
                        inizioValidita: provincia?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: provincia?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={ProvinciaSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Descrizione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="descrizione"
                                                            name="descrizione"
                                                            value={values.descrizione}
                                                            onChange={handleChange}
                                                            error={touched.descrizione && Boolean(errors.descrizione)}
                                                            helperText={touched.descrizione && errors.descrizione}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Sigla
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="sigla"
                                                            name="sigla"
                                                            value={values.sigla}
                                                            onChange={handleChange}
                                                            error={touched.sigla && Boolean(errors.sigla)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Regione
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="descrizione"
                                                            component={Autocomplete}
                                                            options={regioniOptions}
                                                            onInputChange={(e, value) => getRegioniAsync(value)}
                                                            onChange={(e, value) => {
                                                                setFieldValue('regioneId', value?.regioneId)
                                                            }}
                                                            value={regioniOptions.find(option => option.regioneId == values.regioneId) ?? null}
                                                            renderInput={(params) => <TextField {...params}
                                                                label="Scegli..." />}
                                                            fullWidth
                                                        />
                                                        {
                                                            errors.regioneId &&
                                                            <Typography color="error">
                                                                {errors.regioneId}
                                                            </Typography>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={provincia?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={provincia?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={provincia?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={provincia?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}